import Api from "./api";
import { EmissionValues } from "../containers/quotation/types/emission";
import { Observable } from "rxjs";
import { EmissionState } from "../redux/emission/state";
import { map } from "rxjs/operators";
import { ISSUANCE_DATA } from "../constants/enums/emission";
import { COD_APPLICATION } from "../constants/payroll-file";

export class EmissionApi {
    static URL =
        "ms-ne-inicia-emisiones-vida-ley-empleados-vda/emision/vida-ley-empleados/v1";
    static startEmission = ({
        numberQuotes,
        idTransaction,
    }: {
        numberQuotes: number;
        idTransaction: number;
    }) =>
        Api.post(`${EmissionApi.URL}/emission/getStart`, {
            entity: {
                flagCodeRequest: 1,
                idBroker: ISSUANCE_DATA.ID_BROKER,
                idTransaction: idTransaction,
                movementType: 1,
                numberQuotes: numberQuotes,
                systemCode: "GW",
                codigoaplicacion: COD_APPLICATION,
            },
        });

    static saveEmission = (
        emission: EmissionValues
    ): Observable<EmissionState["registerResponse"]> =>
        Api.post(
            "ms-ne-registra-emisiones-vida-ley-empleados-vda/emision/vida-ley-empleados/v1/emisiones/registrar",
            {
                entity: emission,
            }
        ).pipe(map((resp) => resp.response));
}
